import Vuex from 'vuex';

const state = {
  youtubeId: '',
  autoPlay: true,
};

const getters = {
  currentYoutubeId: state => state.youtubeId,
  autoPlay: state => state.autoPlay,
};

const actions = {
  play: ({ state, commit }, { youtubeId, autoPlay }) => {
    commit('executePlay', { youtubeId, autoPlay });
  },
  stop: ({ state, commit }) => {
    commit('executeStop');
  },
};

const mutations = {
  executePlay: (state, { youtubeId, autoPlay }) => {
    state.youtubeId = youtubeId;
	state.autoPlay = autoPlay;
  },
  executeStop: (state) => {
    state.youtubeId = '';
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./store/modules/youtube.js